import React, { Component } from 'react'
import logo from './Logo.png';
import './App.css';
import Contact from './components/contact';
import JsonData from './data/data.json';

export class App extends Component {
  state = {
    landingPageData: {},
  }
  getlandingPageData() {
    this.setState({landingPageData : JsonData})
  }

  componentDidMount() {
    this.getlandingPageData();
  }

  render(){
    return (
      <div className="App">
        <header className="App-header">
          <div>
            <img src={logo} className="App-logo" alt="logo" />
            <span className="Title">Kosha Moves</span>
          </div>
         
        </header>
        <Contact data={this.state.landingPageData.Contact} />
      </div>
    );
  }  
}

export default App;
